<template>
    <!-- 用户列表 -->
    <vRoleRow :postList="postList" v-if="flag"></vRoleRow>
</template>
<script>
import vRoleRow from '../listComponent/jurisdiction/roleRowComponent.vue';
export default {
    name: 'roleRow',
    components: {
        vRoleRow
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                object_type: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },

    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>